import { Button, ButtonProps } from "@mui/material";

const DialogActionSecondary: React.FC<ButtonProps> = ({ ...props }) => <Button {...props} variant="outlined" />;

export default DialogActionSecondary;
